<template>
  <div class="b-video" :data-video-id="videoId">
    <div class="b-video__iframe">
      <div :id="guid" class="player"></div>
    </div>

    <div class="b-video__body">
      <div class="overlay"></div>

      <div class="e-play">
        <span>{{ dictionary.playLabel }}</span>
        <i class="icon-play"></i>
      </div>

      <LazyImage v-if="image" :image="image" />
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import LazyImage from './../components/common/LazyImage.vue'

export default {
  components: { LazyImage },
  props: {
    videoId: {
      required: true,
      type: String,
    },
    image: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      guid: `id${uuidv4()}`,
    }
  },
}
</script>
